import type React from 'react';

import { Card, CardBody, Text } from '@change/ds-core-ui';

import { translationKey } from '@change-corgi/core/i18n';
import { TypedTranslate } from '@change-corgi/core-react/i18n';

import { GradientPanel, SectionIntro } from '#src/app/pages/about/shared/components';

import { PRINCIPLES } from './consts';

export const GuidingPrinciples: React.FC<EmptyProps> = () => {
	return (
		<section className="container flex flex-col gap-10 pb-16 md:gap-14 md:pb-32">
			<SectionIntro
				eyebrow={translationKey('corgi.vision_page.principles.eyebrow')}
				heading={translationKey('corgi.vision_page.principles.heading')}
				align="center"
			/>
			<GradientPanel data-qa="vision-principles-panel">
				<div className="grid grid-cols-1 gap-5 md:grid-cols-2" data-qa="vision-principles-grid">
					{PRINCIPLES.map(({ id, numeral, title, body }) => (
						<Card key={id} className="bg-background-base content-start rounded-2xl">
							<CardBody className="flex flex-col gap-4">
								<Text variant="heading" size="x-large" fontWeight="bold" className="text-typography-brand">
									<TypedTranslate value={numeral} />
								</Text>
								<Text as="h3" variant="heading" size="small" fontWeight="bold">
									<TypedTranslate value={title} />
								</Text>
								<Text as="p" className="text-typography-weak">
									<TypedTranslate value={body} />
								</Text>
							</CardBody>
						</Card>
					))}
				</div>
			</GradientPanel>
		</section>
	);
};
